import { useState, useEffect, useMemo } from 'react';
import { debounce } from '../helpers/debounce.es.js';

const DELAY = 300;
const useQuantity = (addToCart, baseQuantity = 0) => {
  const [qty, setQty] = useState((addToCart == null ? void 0 : addToCart.quantityInCart) || baseQuantity);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (addToCart && !loading) {
      setQty(addToCart.quantityInCart);
    }
  }, [addToCart]);
  const handleUpdateQty = async () => {
    if (qty && qty !== addToCart.quantityInCart) {
      setLoading(true);
      await addToCart.onChangeQuantity(qty);
      setLoading(false);
    } else {
      setQty(addToCart.quantityInCart);
    }
  };
  const debounceChange = useMemo(() => debounce(async (q) => {
    setLoading(true);
    if (q === 0 && (addToCart == null ? void 0 : addToCart.onRemoveItem))
      await addToCart.onRemoveItem();
    else
      await addToCart.onChangeQuantity(q);
    setLoading(false);
  }, DELAY), [addToCart]);
  const onIncrease = () => {
    setQty(qty + 1);
    debounceChange(qty + 1);
  };
  const onDecrease = () => {
    setQty(qty - 1);
    debounceChange(qty - 1);
  };
  return {
    qty,
    setQty,
    handleUpdateQty,
    onIncrease,
    onDecrease
  };
};

export { useQuantity };
